import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ImageBlockImage, ImageBlock } from '../../models/images-block';
import { ContentBlockLayout, IContentBlockControl } from '../../models/content-block-control';
import { get } from 'lodash';

const compactImageSize = 100;

@Component({
  selector: 'app-images-block',
  templateUrl: './images-block.component.html',
  styleUrls: ['./images-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ImagesBlockComponent implements OnInit, IContentBlockControl {
  @Input()
  public get imagesBlock(): ImageBlock {
    return this._imagesBlock;
  }
  public set imagesBlock(value: ImageBlock) {
    this._imagesBlock = value;

    const images = get(value, 'images', []);
    if (images.length) {
      this.images = images;
      this.currentImage = this.images[0];
    }
  }
  private _imagesBlock: ImageBlock;

  @Input()
  layout = ContentBlockLayout.Normal;

  get fit(): 'normal' | 'auto' {
    return this.layout === 'compact' ? 'auto' : 'normal';
  }

  get fitSize(): number {
    return this.layout === 'compact' ? compactImageSize : undefined;
  }

  images: ImageBlockImage[];
  currentImage: ImageBlockImage;

  constructor() {}

  ngOnInit() {}

  handlePrevClick() {
    let currentImageIndex = this.getCurrentImageIndex();
    currentImageIndex--;

    if (currentImageIndex < 0) {
      currentImageIndex = this.images.length - 1;
    }

    this.currentImage = this.images[currentImageIndex];
  }

  handleNextClick() {
    let currentImageIndex = this.getCurrentImageIndex();
    currentImageIndex++;

    if (currentImageIndex >= this.images.length) {
      currentImageIndex = 0;
    }

    this.currentImage = this.images[currentImageIndex];
  }

  getCurrentImageIndex() {
    return this.images.indexOf(this.currentImage);
  }
}
